// Конфигурация для API Gateway
export const API_GATEWAY_URL = import.meta.env.VITE_API_GATEWAY_URL || '/api';
// URL для авторизационного сервиса
export const AUTH_SERVICE_URL = import.meta.env.VITE_AUTH_SERVICE_URL || '/api';
// URL для API талантов (используем относительный путь для работы с Vite прокси)
export const API_URL = import.meta.env.VITE_API_URL || '/api';
// Название сервиса
export const SERVICE_NAME = import.meta.env.VITE_SERVICE_NAME || 'talent-service';
// API Token для публичных запросов
export const PUBLIC_API_TOKEN = import.meta.env.VITE_PUBLIC_API_TOKEN || '';
// ISO код внутреннего клиента для публичного фида постов
export const INNER_CLIENT_ISO = import.meta.env.VITE_INNER_CLIENT_ISO || null;
// Общий виджет Clock In / Clock Out, раздаётся attendance-service (пусто = выключен)
export const CLOCK_WIDGET_URL = import.meta.env.VITE_CLOCK_WIDGET_URL || '';

// Notifications widget (bell + page) served by auth-user-services (empty = off)
export const NOTIFICATIONS_WIDGET_URL = import.meta.env.VITE_NOTIFICATIONS_WIDGET_URL || '';
// Notifications WebSocket of auth-user-services (the gateway does not proxy WS); empty → same host /ws
export const AUTH_WS_URL = import.meta.env.VITE_AUTH_WS_URL || '';

export default {
  API_GATEWAY_URL,
  AUTH_SERVICE_URL,
  API_URL,
  SERVICE_NAME,
  PUBLIC_API_TOKEN,
  INNER_CLIENT_ISO,
};